/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatter_Ref_N4Inputs */

const en_formatter_ref_n4 = /** @type {(inputs: Formatter_Ref_N4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duplicate keys are legal to parse but only the last one survives. Nothing warns you.`)
};

const ko_formatter_ref_n4 = /** @type {(inputs: Formatter_Ref_N4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`중복 키는 파싱은 되지만 마지막 것만 살아남습니다. 아무런 경고도 없습니다.`)
};

const ja_formatter_ref_n4 = /** @type {(inputs: Formatter_Ref_N4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重複キーはパースできますが、最後のものだけが残ります。警告は一切出ません。`)
};

/**
* | output |
* | --- |
* | "Duplicate keys are legal to parse but only the last one survives. Nothing warns you." |
*
* @param {Formatter_Ref_N4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const formatter_ref_n4 = /** @type {((inputs?: Formatter_Ref_N4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatter_Ref_N4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatter_ref_n4(inputs)
	if (locale === "ko") return ko_formatter_ref_n4(inputs)
	return ja_formatter_ref_n4(inputs)
});